import * as React from "react";

function SvgStorage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 29.364l2.727-2.728h17.728V43H12V29.364zm17.727 0H27v2.727h2.727v-2.727zm-4.09 0h-2.728v2.727h2.727v-2.727zm-4.091 0h-2.728v2.727h2.727v-2.727zm-4.091 0h-2.728v2.727h2.727v-2.727zM27 33.454h2.727v2.728H27v-2.727zm0 4.091h2.727v2.728H27v-2.728zm-12.273 2.728h2.727v-2.728h-2.727v2.728zm4.091 0h2.727v-2.728h-2.727v2.728zm4.091 0h2.727v-2.728H22.91v2.728zm2.727-6.819v2.728H22.91v-2.727h2.727zm-4.09 0v2.728h-2.728v-2.727h2.727zm-4.091 0v2.728h-2.728v-2.727h2.727z"
        fill="#fff"
      />
      <path
        d="M22.91 15.727L25.635 13h17.728v16.364h-4.091v-2.728h1.363V23.91h-1.363v-1.363h1.363v-2.728h-1.363v-1.364h1.363v-2.727H37.91v2.727h-1.364v-2.727h-2.727v2.727h-1.363v-2.727h-2.728v2.727h-1.363v-2.727h-2.728v2.727H22.91v-2.727z"
        fill="#fff"
      />
      <path
        d="M17.454 22.546l2.728-2.728h17.727v16.364h-4.09v-2.727h1.363v-2.728h-1.364v-1.363h1.364v-2.728h-1.364v-1.363h1.364v-2.727h-2.727v2.727H31.09v-2.727h-2.727v2.727H27v-2.727h-2.727v2.727h-1.364v-2.727h-2.727v2.727h-2.727v-2.727z"
        fill="#fff"
      />
      <circle cx={28} cy={28} r={27} stroke="#fff" />
    </svg>
  );
}

export default SvgStorage;
